<script lang="ts">
	import SalesSlugPage from "./sales-slug-page.svelte";
	import type { PublicInvestmentListing } from "@fergmar/contracts/public/investment-listings";

	type PublicListing = PublicInvestmentListing;

	let {
		salesTeam,
		listing
	}: {
		salesTeam: {
			displayName: string;
			title: string;
			headshot: string;
			workEmail: string;
			workNumber: string | null;
		}[];
		listing: PublicListing;
	} = $props();
</script>

<SalesSlugPage {listing} {salesTeam} />
